
const WarningCircleIcon = () => {
    return (
        <svg className={"svg-icon"} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                stroke="#F67A24" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 7.5V12.75" stroke="#F67A24" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M12 17.625C12.8284 17.625 13.5 16.9534 13.5 16.125C13.5 15.2966 12.8284 14.625 12 14.625C11.1716 14.625 10.5 15.2966 10.5 16.125C10.5 16.9534 11.1716 17.625 12 17.625Z"
                fill="#F67A24"/>
        </svg>
    )
}

export default WarningCircleIcon